module.exports = function searchingPresenter(isSearching) {
    const view = require('./searchingPresenter.tpl.html');
    const c = {};

    c.activate = function(region) {
        view.activate(region);
        isSearching.subscribeChange(onSearchingChange);
        onSearchingChange();
    };

    function onSearchingChange() {
        if(isSearching()) {
            view.wrapper.classList.add('searchingPresenter-isSearching');
        } else {
            view.wrapper.classList.remove('searchingPresenter-isSearching');
        }
    }

    c.deactivate = function() {
        isSearching.unsubscribeChange(onSearchingChange);
        view.deactivate();
    };

    return c;
}
